import { getDictDataByType, getAllMapPoint, findTourismInfoById } from '@/api/index.js';
import menuLayerTreePup from './menuLayerTreePup.vue';
import { point } from '@turf/turf';
export default {
  name: 'menuLayerTree',
  data() {
    return {
      value: false,
      selectIndex: -1,
      oneLevelArr: [],
      selectOne: -1,
      selectTwo: -1,
      selectThree: -1,
      selectNewOrLod: -1,
      twoLevelArr: [],
      threeLeveArr: [],
      primaryLevelArr: [],
      newOrLodArr: [
        {
          title: '全部资源',
          value: '',
        },
        {
          title: '新发现资源',
          value: '1',
        },
      ],
      flagSearch: true,
      dataList: [],
      totalNumber: 100,
      monomerName: '',
      searchParam: {
        pageNumber: 1,
        pageSize: 10,
        areaCode: [],
        mainTypeName: '', //主类
        subtypeName: '', //亚类
        monomerName: '', //单体名称
        maybeGrade: '', //景区等级
        developed: '', //新发现资源
        wktStr: '', //JSON数据
        basicTypeName: '',
        areaCodes: [],
      },
      searchParamAll: {
        pageNumber: 1,
        pageSize: 100000,
        areaCode: '',
        mainTypeName: '', //主类
        subtypeName: '', //亚类
        monomerName: '', //单体名称
        maybeGrade: '', //景区等级
        developed: '', //新发现资源
        wktStr: '', //JSON数据
        basicTypeName: '',
        areaCodes: [],
      },
      allPointList: [],
      monitorPointVectorLayerBig: null,
      convertor: new BMapGL.Convertor(),
      selectOneArr: [],
      selectTowArr: [],
      selectThreeArr: [],
      selectFourArr: [],
      layerPup: null,
      propImgArr: [], //选择的气泡的图片上数据集合,
      points: [],
    };
  },
  created() {
    this.getOneLever();
    this.getResourceLevel();
    this.getAllPoint(); //获取所有的数据不分页
    this.getPageList(); //获取分页的数据
  },
  mounted() {
    // 选择市抛事件
    this.$bus.$off('selectArea');
    this.$bus.$on('selectArea', data => {
      if (data.length != -1) {
        this.searchParam.areaCodes = [];
        this.searchParam.pageNumber = 1;
        this.searchParamAll.areaCodes = [];
        data.forEach(item => {
          this.searchParam.areaCodes.push(item.value);
          this.searchParamAll.areaCodes.push(item.value);
        });
      }
      this.getAllPoint(); //获取所有的数据不分页
      this.getPageList(); //获取分页的数据
    });
    this.$bus.off('drawPolygon');
    this.$bus.on('drawPolygon', data => {
      if (data) {
        this.searchParam.wktStr = data;
        this.searchParamAll.wktStr = data;
        this.handleSubmit();
      } else {
        this.searchParam.wktStr = '';
        this.searchParamAll.wktStr = '';
        this.handleSubmit();
      }
    });
  },
  methods: {
    /*
     *@description:
     *@author: qqjuanqq
     *@date: 2023-06-29 11:29:12
     *@version: V1.0.0
     */
    getAllPoint() {
      console.log(this.allPointList);
      getAllMapPoint(this.searchParamAll)
        .then(res => {
          if (res.code == 200 && res.success) {
            // this_.$set(this_.allPointList, res.result.records)
            if (
              this.allPointList.length != res.result.records.length &&
              this.allPointList.length != 0
            ) {
              if (this.points.length > 0) {
                this.points.forEach(item => {
                  window.BDMap.removeOverlay(item);
                });
                this.points = []; // 清空 points 数组
              }
            }
            this.allPointList = res.result.records;
            this.totalNumber = res.result.total;
            this.$bus.emit('setOlbaseMapPoint', this.allPointList);
            console.log(this.allPointList);
            // 将点叠加到地图上
            var markers = [];
            this.allPointList.length > 0 &&
              this.allPointList.forEach((item, index) => {
                var srcurl = require('../../../../static/img/level/level.png');
                switch (item.maybeGrade) {
                  case '五级':
                    srcurl = require('../../../../static/img/level/level5.png');
                    break;
                  case '四级':
                    srcurl = require('../../../../static/img/level/level4.png');
                    break;
                  case '三级':
                    srcurl = require('../../../../static/img/level/level3.png');
                    break;
                  case '二级':
                    srcurl = require('../../../../static/img/level/level2.png');
                    break;
                  case '一级':
                    srcurl = require('../../../../static/img/level/level1.png');
                    break;
                  default:
                    srcurl = require('../../../../static/img/level/level.png');
                    break;
                }
                let point = new BMapGL.Point(item.longitude, item.latitude);

                this.convertor.translate([point], COORDINATES_GCJ02, COORDINATES_BD09, data => {
                  if (data.status === 0) {
                    let marker = new BMapGL.Marker(data.points[0], {
                      icon: this.createdIcon(srcurl),
                      iconSize: new BMapGL.Size(30, 30),
                      _id: item.id,
                    });
                    this.points.push(marker);
                    marker.addEventListener('click', async e => {
                      let { result } = await findTourismInfoById({ id: e.target._config._id });
                      let dataListIndex = -1;
                      this.dataList.forEach((item, index) => {
                        if (item.id == result.id) {
                          dataListIndex = index;
                        }
                      });
                      if (dataListIndex != -1) {
                        this.selectIndex = dataListIndex;
                      } else {
                        result.imgUrl = result.imageList[0].url;
                        this.dataList.push(result);
                        this.selectIndex = this.dataList.length - 1;
                      }

                      this.flagSearch = false;
                      window.BDMap.centerAndZoom(data.points[0], 10);
                      // this.openMapLayer(result);
                      this.PopWinFea(result);
                    });
                    window.BDMap.addOverlay(marker, point);
                  }
                });
              });
          }
        })
        .catch(err => {
          this.$Message.info('数据获取失败!');
        });
    },
    //按区域选择的事件
    PopWinFea(feaData) {
      console.log('xcxxxxxxxxx' + feaData);
      var title = '基本信息';
      var imgStr = '';
      var imgArr = feaData.imageList;
      this.propImgArr = imgArr;
      var imgArr = feaData.imageList;
      if (imgArr.length > 0) {
        imgArr.forEach((it, i) => {
          // imgStr += `<li class="lisImg" onclick="previewImg(${i})">
          imgStr += `<li class="lisImg">
            <img src='${it.url}' alt="" class="imgCodeCal"/>
          </li>`;
        });
      }

      var tbHtml = '';
      tbHtml += `<div class='spInfo ivu-table-wrapper' style='height: 298px;position:relative;'><div  class='spAllinfo' style='height: 90%;
      overflow: auto;'>
          <div class="titleCon">资源名称:${feaData.monomerName}</div>
          <div class="contentLis">
            <div class="popTitle">景 点 等 级:</div>
            <div class="popConText">${feaData.maybeGrade}</div>
          </div>
          <div class="contentLis">
            <div class="popTitle">是否新发现:</div>
            <div class="popConText">${feaData.newFind && feaData.newFind == 1 ? '是' : '否'}</div>
          </div>
          <div class="contentLis">
            <div class="popTitle">景 点 位 置:</div>
            <div class="popConText">${feaData.administrativeLocation}</div>
          </div>
          <ul class="imgcal">
            ${imgStr}
          </ul>
        </div>`;
      var TXTHTML = `<div class='bottom_btn' style='position: absolute;bottom: 0px;right: 0px;z-index:666;'>
        <div onclick='goDetail("${feaData.id}")' style='height:30px;line-height:35px;'>查看详情>></div>
      </div>`;
      tbHtml += TXTHTML;
      var opts = {
        width: 400, // 信息窗口宽度
        height: 310, // 信息窗口高度
        title, // 信息窗口标题
      };
      let point = new BMapGL.Point(feaData.longitude, feaData.latitude);
      var infoWindow = new BMapGL.InfoWindow(tbHtml, opts); // 创建信息窗口对象
      window.BDMap.openInfoWindow(infoWindow, point); //开启信息窗口
    },
    previewImg(index) {
      const viewer = this.$el.querySelector('.imgCodeCal').$viewer;
      viewer.show();
    },
    openMapLayer(data) {
      this.$layer.close(this.layerPup);
      this.layerPup = this.$layer.iframe({
        content: {
          content: menuLayerTreePup,
          parent: this,
          data: { data },
        },
        area: ['800px', '370px'],
        title: '单体评价',
        maxmin: false,
        shade: false,
        shadeClose: false,
        cancel: () => {},
      });
    },

    createdIcon(icon) {
      return new BMapGL.Icon(icon, new BMapGL.Size(30, 38), {
        anchor: new BMapGL.Size(15, 48),
      });
    },
    changePage(v) {
      console.log('v' + v);
      this.searchParam.pageNumber = v;

      this.getPageList();
    },
    changePageSize(v) {
      this.searchParam.pageSize = v;
      this.getPageList();
    },
    /*
     *@description: 分页获取列表的数据
     *@author: qqjuanqq
     *@date: 2023-06-29 15:05:44
     *@version: V1.0.0
     */
    getPageList() {
      getAllMapPoint(this.searchParam).then(res => {
        if (res.code == 200 && res.success) {
          this.dataList = res.result.records;
        }
      });
    },
    /*
     *@description:资源分类的接口
     *@modifyContent:
     *@author: qqjuanqq
     *@date: 2023-06-19 17:37:16
     */
    getResourceLevel() {
      getDictDataByType('resourceLevel').then(res => {
        if (res.code == 200 && res.success) {
          res.result.forEach(item => {
            item['flag'] = false;
          });
          this.primaryLevelArr = res.result;
        }
      });
    },
    /*
     *@description: 获取一级分类的接口
     *@author: qqjuanqq
     *@date: 2023-06-19 15:51:37
     *@version: V1.0.0
     */
    getOneLever() {
      getDictDataByType('primaryClassification').then(res => {
        if (res.code == 200 && res.success) {
          this.oneLevelArr = res.result;
          this.oneLevelArr.forEach(item => {
            item['flag'] = false;
          });
          // this.oneLevelArr.unshift({
          //   title: '全部',
          //   id: 'all',
          //   value: '',
          // });
        }
      });
    },
    /*
     *@description: 选择一级分类的事件
     *@author: qqjuanqq
     *@date: 2023-06-19 16:22:54
     *@version: V1.0.0
     */
    selectOneLeavl(index) {
      this.oneLevelArr[index].flag = !this.oneLevelArr[index].flag;
      var oneObjData = this.oneLevelArr[index];
      if (this.oneLevelArr[index].flag) {
        this.selectOneArr.push(oneObjData.value);
      } else {
        this.selectOneArr.forEach((item, idx) => {
          if (item == oneObjData.value) {
            this.selectOneArr.splice(idx, 1);
            this.selectTowArr.forEach((item, ii) => {
              if (item[0] == oneObjData.value) {
                this.selectTowArr.splice(ii, 1);
              }
            });
          }
        });
        this.searchParam.subtypeName =
          this.selectTowArr.length > 0 ? this.selectTowArr.join(',') : '';
        this.searchParamAll.subtypeName =
          this.selectTowArr.length > 0 ? this.selectTowArr.join(',') : '';
      }
      this.searchParam.mainTypeName =
        this.selectOneArr.length > 0 ? this.selectOneArr.join(',') : '';
      this.searchParamAll.mainTypeName =
        this.selectOneArr.length > 0 ? this.selectOneArr.join(',') : '';
      let IDarr = [];
      window.g.tourismBasicTypes.forEach(item => {
        this.selectOneArr.forEach(i => {
          if (item.key == i) {
            item.children.forEach(v => {
              v['flag'] = false;
              IDarr.push(v);
            });
          }
        });
      });
      this.selectTowArr.forEach(item => {
        IDarr.forEach(i => {
          if (i.key == item) {
            i['flag'] = true;
          }
        });
      });
      this.twoLevelArr = IDarr;
      if (this.twoLevelArr.length == 0) {
        this.threeLeveArr = [];
        this.selectThreeArr = [];
        this.searchParam.basicTypeName = '';
        this.searchParamAll.basicTypeName = '';
      }
    },
    /*
     *@description: 选择二级分类的事件
     *@author: qqjuanqq
     *@date: 2023-06-29 18:38:53
     *@version: V1.0.0
     */
    selectSecond(index) {
      this.twoLevelArr[index].flag = !this.twoLevelArr[index].flag;
      var twoObjData = this.twoLevelArr[index];
      if (this.twoLevelArr[index].flag) {
        this.selectTowArr.push(twoObjData.key);
      } else {
        this.selectTowArr.forEach((item, idx) => {
          if (item == twoObjData.key) {
            this.selectTowArr.splice(idx, 1);
            let threeAr = this.selectThreeArr;
            threeAr.forEach((item, ii) => {
              if (item[1] == twoObjData.key[1]) {
                this.selectThreeArr.splice(ii, 1);
              }
            });
          }
          if (!!this.searchParam.basicTypeName) {
            let threeArr = this.searchParam.basicTypeName.split(',');
            let basicTypeNames = [];
            threeArr.forEach(v => {
              if (v != item) {
                basicTypeNames.push(v);
              }
            });
            if (basicTypeNames.length > 0) {
              this.searchParam.basicTypeName = basicTypeNames.join(',');
              this.searchParamAll.basicTypeName = basicTypeNames.join(',');
            }
          }
        });
        this.searchParam.basicTypeName =
          this.selectThreeArr.length > 0 ? this.selectThreeArr.join(',') : '';
        this.searchParamAll.basicTypeName =
          this.selectThreeArr.length > 0 ? this.selectThreeArr.join(',') : '';
      }
      this.searchParam.subtypeName =
        this.selectTowArr.length > 0 ? this.selectTowArr.join(',') : '';
      this.searchParamAll.subtypeName =
        this.selectTowArr.length > 0 ? this.selectTowArr.join(',') : '';
      let arr = [];
      this.twoLevelArr.forEach(item => {
        this.selectTowArr.forEach(i => {
          if (i == item.key) {
            item.children.forEach(v => {
              v['flag'] = false;
              arr.push(v);
            });
          }
        });
      });
      this.selectThreeArr.forEach(item => {
        arr.forEach(i => {
          if (i.key == item) {
            i['flag'] = true;
          }
        });
      });
      this.threeLeveArr = arr;
    },
    selectThird(index) {
      // this.threeLeveArr[index].flag = !this.threeLeveArr[index].flag;
      this.$set(this.threeLeveArr[index], 'flag', !this.threeLeveArr[index].flag);
      this.$forceUpdate();
      var threeObjData = this.threeLeveArr[index];
      if (this.threeLeveArr[index].flag) {
        this.selectThreeArr.push(threeObjData.key);
      } else {
        this.threeLeveArr.forEach((item, idx) => {
          if (item.key == threeObjData.key) {
            this.selectThreeArr.splice(idx, 1);
          }
        });
      }
      this.searchParam.basicTypeName =
        this.selectThreeArr.length > 0 ? this.selectThreeArr.join(',') : '';
      this.searchParamAll.basicTypeName =
        this.selectThreeArr.length > 0 ? this.selectThreeArr.join(',') : '';
    },
    selectResource(index) {
      this.primaryLevelArr[index].flag = !this.primaryLevelArr[index].flag;
      this.$forceUpdate();
      console.log(this.primaryLevelArr);
      let objData = this.primaryLevelArr[index];
      if (objData.flag) {
        this.selectFourArr.push(objData.value);
      } else {
        this.selectFourArr.forEach((item, idx) => {
          if (item == objData.value) {
            this.selectFourArr.splice(idx, 1);
          }
        });
      }
      this.searchParam.maybeGrade =
        this.selectFourArr.length > 0 ? this.selectFourArr.join(',') : '';
      this.searchParamAll.maybeGrade =
        this.selectFourArr.length > 0 ? this.selectFourArr.join(',') : '';
    },
    /*
     *@description:
     *@author: szc
     *@date: 2023-06-29 18:44:47
     *@version: V1.0.0
     */
    selectNewOrLodCode(index) {
      this.selectNewOrLod = index;
      var newOrLodData = this.newOrLodArr[index];
      this.searchParam.developed = newOrLodData.value;
      this.searchParamAll.developed = newOrLodData.value;
    },
    /*
     *@description:
     *@author: qqjuanqq
     *@date: 2023-06-29 18:44:47
     *@version: V1.0.0
     */
    selectThreeCode(index) {
      this.selectThree = index;
      var threeObjData = this.primaryLevelArr[index];
      this.searchParam.maybeGrade = threeObjData.value;
      this.searchParamAll.maybeGrade = threeObjData.value;
    },
    /*
     *@description: 点击重置
     *@author: qqjuanqq
     *@date: 2023-06-19 17:54:29
     *@version: V1.0.0
     */
    handleReset() {
      let areaCodes = this.searchParam.areaCodes;
      this.searchParam = {
        pageNumber: 1,
        pageSize: 10,
        areaCodes: areaCodes,
        mainTypeName: '', //主类
        subtypeName: '', //亚类
        monomerName: '', //单体名称
        maybeGrade: '', //景区等级
      };
      this.searchParamAll = {
        pageNumber: 1,
        pageSize: 100000,
        areaCodes: areaCodes,
        mainTypeName: '', //主类
        subtypeName: '', //亚类
        monomerName: '', //单体名称
        maybeGrade: '', //景区等级
      };
      this.threeLeveArr = [];
      this.selectThreeArr = [];
      this.twoLevelArr = [];
      this.selectTowArr = [];
      this.selectOneArr = [];
      this.getOneLever();
      (this.selectOne = -1),
        (this.selectTwo = -1),
        (this.selectThree = -1),
        (this.monomerName = '');
      this.primaryLevelArr.forEach(item => {
        item.flag = false;
      });
      this.getPageList(); //获取分页的数据
      this.getAllPoint(); //获取所有的数据不分页
    },
    /*
     *@description: 点击查询
     *@author: qqjuanqq
     *@date: 2023-06-19 17:54:57
     *@version: V1.0.0
     */
    handleSubmit() {
      this.searchParam.monomerName = this.monomerName;
      this.searchParamAll.monomerName = this.monomerName;
      this.getPageList(); //获取分页的数据
      this.getAllPoint(); //获取所有的数据不分页
      setTimeout(() => {
        this.flagSearch = false;
      }, 100);
    },
    /*
     *@description: 还原状态
     *@author: qqjuanqq
     *@date: 2023-06-19 18:54:29
     *@version: V1.0.0
     */
    closeView() {
      this.flagSearch = true;
    },
    /*
     *@description: 选择点的事件
     *@author: qqjuanqq
     *@date: 2023-06-29 15:13:38
     *@version: V1.0.0
     */
    selectPoint(index) {
      this.selectIndex = index;
      var objDaya = this.dataList[index];
      this.$bus.$emit('selectPoint', objDaya);
      let point = new BMapGL.Point(objDaya.longitude, objDaya.latitude);
      this.convertor.translate([point], COORDINATES_GCJ02, COORDINATES_BD09, async data => {
        if (data.status === 0) {
          window.BDMap.centerAndZoom(data.points[0], 10);
          let { result } = await findTourismInfoById({ id: objDaya.id });
          // this.openMapLayer(result);
          this.PopWinFea(result);
        }
      });
      // if (objDaya.longitude && objDaya.latitude) {
      //   this.olmap.getView().animate({
      //     center: [objDaya.longitude, objDaya.latitude],
      //     duration: 2000,
      //     zoom: 10,
      //     easing: this.$olmap.easing.Linear,
      //   });
      // }
    },
    /*
     *@description:
     *@author: qqjuanqq
     *@date: 2023-06-29 19:18:21
     *@version: V1.0.0
     */
    reverseSearch() {
      this.flagSearch = true;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/leftmenu/layers/menuLayerTree.js